import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import StickyHeader from "@pages/Admin/Modules/Projects/Detail/StickyHeader";
import { getValue } from "@utils/lodash";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { createGL, getSpecificGL, updateGL } from "@services/gl.service";
import GlForm from "./glForm";

function GlDetailsPage(props: any) {
  const params = useParams();
  const navigate = useNavigate();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [request, setRequest] = useState({
    gl_name: "",
    gl_code: "",
    description: "",
  });

  useEffect(() => {
    if (!params.id) return;

    const getData = async () => {
      try {
        const resp = await getSpecificGL(params.id as string);
        const data = getValue(resp, `data`, {});
        setRequest({
          gl_name: getValue(data, `gl_name`, ""),
          gl_code: getValue(data, `gl_code`, ""),
          description: getValue(data, `description`, ""),
        });
      } catch (error) {}
    };

    getData();
  }, [params.id]);

  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }

    const payload = {
      gl_name: getValue(request, `gl_name`, ""),
      gl_code: getValue(request, `gl_code`, ""),
      description: getValue(request, `description`, ""),
      is_active: true,
    };

    setSubmitLoading(true);
    try {
      if (params.id) {
        const resp = await updateGL(params.id, payload);
        if (!resp) return;

        toast.success(getValue(resp, `message`, ""));
      } else {
        const resp = await createGL(payload);
        if (!resp) return;

        toast.success(getValue(resp, `message`, ""));
      }

      navigate("/admin/modules/GL");
    } catch (error) {
      return;
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      <StickyHeader
        isChanged={false}
        handleSubmit={handleSubmit}
        submitLoading={submitLoading}
        id={params.id}
        route={"/admin/modules/GL"}
        title={`${getValue(params, `id`, "") ? "Update" : "New"}${" "}GL`}
        permissions={getValue(props, `permissions`, [])}
        showActionButtons={true}
      />
      <GlForm
        request={request}
        setRequest={setRequest}
        simpleValidator={simpleValidator}
        handleChangeText={handleChangeText}
      />
    </DashboardLayout>
  );
}

export default GlDetailsPage;